import React from 'react';

const Toggle = ({ active, variant, size, onClick = () => {}, onChange, disabled = false, className }) => {
  const handleClick = (e) => {
    if (disabled) {
      return;
    }
    onClick(e);
    if (onChange) {
      onChange(!active);
    }
  };

  return (
    <div className={`comp-toggle ${active ? 'active' : ''} ${variant || ''} ${size || ''} ${disabled ? 'disabled' : ''} ${className}`} onClick={handleClick}>
      <div />
    </div>
  );
};

export default Toggle;
